import { usePathname } from '#app/lib/hooks/router-compat';

import { useWorkspace } from "#app/lib/data/workspace-context";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";

export function useSidebarNav() {
  const pathname = usePathname();
  const { push } = useAppNavigate();
  const { activeWorkspace } = useWorkspace();

  const wp = activeWorkspace?.urlPath ?? "";

  const isActive = (route: string, exact?: boolean) => {
    const stripped = wp
      ? pathname.replace(`/${wp}`, "") || "/"
      : pathname;

    if (route === "/") return stripped === "/" || stripped === "";
    if (exact) return stripped === route;
    return stripped === route || stripped.startsWith(`${route}/`);
  };

  return { pathname, navigate: push, isActive };
}
